import React from 'react';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { browserHistory } from 'react-router';
import { isDirty } from 'redux-form';
import { push } from 'react-router-redux';

import {
  ContentWrapper,
  PageWrapper,
  LeftColumnWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import {
  pageRequest,
  setDeletedSalesType,
  handleFailedAsyncJob,
  handleSuccessAsyncJob,
  hideDeleteModal,
  deleteSalesType,
  showSalesTypeDeletableModal,
} from 'actions/businessLibrary/salesType';
import { askConfirmAction } from 'actions/confirm-action';
import ConfirmModal from 'components/ConfirmModal';
import ConfirmActionModal from 'components/ConfirmActionModal';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import { PUSHER_APP_KEY } from 'api/constants';

import List from './List';
import SalesTypeDetail from './SalesTypeDetail';
import ActionBar from './ActionBar';
import NoGratuityModal from './NoGratuityModal';
import styles from './SalesType.css';

class SalesType extends React.Component {
  componentDidMount() {
    const { dispatch, businessId } = this.props;
    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });
    this.channel = pusher.subscribe(`moka-${businessId}`);
    browserHistory.listenBefore(this.routerWillLeave);
    dispatch(pageRequest());
  }

  componentDidUpdate() {
    const { dispatch, eventAsyncJob } = this.props;
    if (this.channel) {
      this.channel.unbind();
    }
    if (eventAsyncJob.channelName !== null) {
      this.channel.bind(eventAsyncJob.channelName, data => {
        if (data.job_id && data.success) {
          dispatch(handleSuccessAsyncJob(data.resource_id));
        } else if (data.job_id && !data.success) {
          dispatch(handleFailedAsyncJob(data.error));
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const {
      checkDeletableModalType,
      deletedSalesType,
      showLoadingSpinnerPage,
      salesType,
      openRightColumn,
      showCheckDeletableModal,
      showDeleteModal,
    } = this.props;
    const salesTypeName = deletedSalesType ? deletedSalesType.name : '';

    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={salesType.length === 0}
              title="No Data To Display"
              description={
                <div>
                  Learn more about{' '}
                  <a
                    className={styles['link-creating-sales-type']}
                    href="https://mokaposhelp.zendesk.com/hc/id/articles/900000454066-Cara-Membuat-Sales-Type-How-to-Create-Sales-Type"
                    target="_blank"
                  >
                    Create Sales Type
                  </a>
                </div>
              }
            />
            {salesType.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <SalesTypeDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title="Sales Type"
          name={salesTypeName}
          onDelete={this._onDelete}
        />
        <ConfirmModal
          showModal={showCheckDeletableModal}
          title={`${checkDeletableModalType} Sales Type`}
          description={`You cannot ${
            checkDeletableModalType === 'Delete' ? 'delete' : 'deactivate'
          } this sales type because one or more items are still using it for Sales Type pricing.`}
          onConfirm={this._onHideSalesTypeDeletableModal}
          confirmTitle="OK"
          onHide={this._onHideSalesTypeDeletableModal}
          hideCancelButton
          cancelTitle="No"
          baseColor="danger"
        />
        <NoGratuityModal />
      </PageWrapper>
    );
  }

  _onHideModal = () => {
    const { dispatch } = this.props;
    dispatch(setDeletedSalesType(null));
    dispatch(hideDeleteModal());
  };

  _onHideSalesTypeDeletableModal = () => {
    this.props.dispatch(showSalesTypeDeletableModal(false, ''));
  };

  _onDelete = () => {
    const { dispatch, salesType, deletedSalesType } = this.props;
    dispatch(deleteSalesType(deletedSalesType, salesType));
  };

  routerWillLeave = location => {
    const { isDirtySalesType } = this.props;
    if (isDirtySalesType && !this.props.nextAction) {
      this.props.dispatch(askConfirmAction(push(location)));
      return false;
    }
  };
}

function mapStateToProps(state) {
  const {
    checkDeletableModalType,
    deletedSalesType,
    eventAsyncJob,
    salesType,
    openRightColumn,
    showCheckDeletableModal,
    showDeleteModal,
  } = state.businessLibrary.salesTypeHub;
  const { nextAction } = state.confirmAction;
  const isDirtySalesType = isDirty('salesTypeHub')(state);
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  return {
    checkDeletableModalType,
    deletedSalesType,
    eventAsyncJob,
    openRightColumn,
    salesType,
    showDeleteModal,
    showCheckDeletableModal,
    showLoadingSpinnerPage,
    isDirtySalesType,
    nextAction,
    businessId: state.moka.user.business.id,
  };
}

export default connect(mapStateToProps)(SalesType);
